export default "__VITE_ASSET__BkCC4n4U__"